import { render } from "./PpcBudgetAllocationHeader.vue?vue&type=template&id=5101131e&scoped=true"
import script from "./PpcBudgetAllocationHeader.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationHeader.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationHeader.vue?vue&type=style&index=0&id=5101131e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5101131e"]])

export default __exports__